import { FC } from "react"
import { OneLineAmount, OneLineAmountProps } from "../OneLineAmount"
import { BaseCellContainer } from "./BaseCellContainer"

export const OneLineAmountCell: FC<OneLineAmountProps> = props => (
  <BaseCellContainer>
    <OneLineAmount {...props} />
  </BaseCellContainer>
)
